import React from 'react';
import PropTypes from 'prop-types';
import ControlP from '../../atoms/control/ControlP';
import InputLabel from '../../atoms/inputs/input-label';
import S3FilePicker from '../../molecules/filepickers/s3-file-picker/S3FilePicker';
import SubmitButton from '../../atoms/submit-button/index.ts';
import InputContainer from '../../atoms/inputs/input-container';
import styles from './styles.scss';

class CampaignListUploader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fileIsValid: false,
            fileError: '',
            nameIsValid: false,
            nameError: '',
            appealIsValid: false,
            appealError: '',
            show: false,
        };

        this.validateFile = this.validateFile.bind(this);
        this.validateName = this.validateName.bind(this);
        this.validateAppeal = this.validateAppeal.bind(this);
        this.getForm = this.getForm.bind(this);
    }

    handleClick() {
        this.setState(() => ({
            show: true,
        }));
    }

    getForm() {
        const {
            fileIsValid,
            fileError,
            nameIsValid,
            nameError,
            appealIsValid,
            appealError,
        } = this.state;

        const {
            bucketpath,
            policy,
            xamzcredential,
            xamzdate,
            xamzsignature,
        } = this.props;

        const invalid = !fileIsValid || !nameIsValid || !appealIsValid;

        return (
            <form method="post" className={styles.campaignlistuploader}>
                <ControlP>
                    <InputLabel>Name for your new list:</InputLabel>
                    <InputContainer
                        name="name"
                        displayname="List Name"
                        passerror={this.validateName}
                        errormessage={nameError}
                        required
                    >
                        <input className="input" type="text" name="name" placeholder="Enter a name for your new list" />
                        <span className="help" data-valmsg-for="name" />
                    </InputContainer>
                </ControlP>
                <ControlP>
                    <InputLabel>Appeal Url for your new list:</InputLabel>
                    <InputContainer
                        passerror={this.validateAppeal}
                        errormessage={appealError}
                        name="targetappeal"
                        displayname="Appeal Url"
                        required
                    >
                        <input className="input" type="text" name="targetappeal" placeholder="Enter the url of the Appeal you wish to target" />
                        <span className="help" data-valmsg-for="targetappeal" />
                    </InputContainer>
                </ControlP>
                <ControlP>
                    <InputLabel>CSV file for your new list:</InputLabel>
                    <InputContainer
                        passerror={this.validateFile}
                        errormessage={fileError}
                        name="file"
                        displayname="Csv File"
                        required
                    >
                        <S3FilePicker
                            maxsize={10}
                            extensions={['.csv']}
                            name="key"
                            bucketpath={bucketpath}
                            policy={policy}
                            xamzcredential={xamzcredential}
                            xamzdate={xamzdate}
                            xamzsignature={xamzsignature}
                            passerror={this.validateFile}
                        />
                        <span className="help" data-valmsg-for="key" />
                    </InputContainer>
                </ControlP>
                <br />
                <SubmitButton isdisabled={invalid} name="campaignlist-upload-submit" />
            </form>
        );
    }

    validateFile(_, error) {
        this.setState(() => ({
            fileError: error,
            fileIsValid: !error,
        }));
    }

    validateName(_, error) {
        this.setState(() => ({
            nameError: error,
            nameIsValid: !error,
        }));
    }

    validateAppeal(_, error) {
        this.setState(() => ({
            appealError: error,
            appealIsValid: !error,
        }));
    }

    render() {
        const { show } = this.state;
        if (show) {
            return this.getForm();
        }

        return <button type="button" className="button is-primary" onClick={this.handleClick.bind(this)}>Click here to upload a Campaign List</button>;
    }
}

CampaignListUploader.propTypes = {
    bucketpath: PropTypes.string.isRequired,
    xamzcredential: PropTypes.string.isRequired,
    xamzdate: PropTypes.string.isRequired,
    policy: PropTypes.string.isRequired,
    xamzsignature: PropTypes.string.isRequired,
};

export default CampaignListUploader;
